import { numberFormatter } from 'core/helpers/formatters';

function CreditCardFeeDisclaimer({ amount, fee }) {
  // Prefer the precomputed fee from the backend; fall back to recomputing from `amount`
  // only when the caller doesn't have one (legacy call sites, rare).
  const displayedFee = typeof fee === 'number' ? fee : !!amount && amount * 0.0285 + 0.25;
  return (
    <div>
      <small>
        *Each credit card payment is subject to a processing fee of <strong>2.85% + $0.25</strong>
        {displayedFee ? (
          <>
            {' '}
            <strong>(${numberFormatter(displayedFee, 2)})</strong>
          </>
        ) : null}
        .
      </small>
    </div>
  );
}

export default CreditCardFeeDisclaimer;
